// Auto-generated curated list combining existing daily pool with additional motivational references
export const MOTIVATIONAL_VERSES_365 = [
  {
    "id": 1,
    "reference": "Joshua 1:9",
    "text": "Have I not commanded you? Be strong and courageous. Do not be afraid; do not be discouraged, for the Lord your God will be with you wherever you go.",
    "translation": "NIV"
  },
  {
    "id": 2,
    "reference": "Isaiah 41:10",
    "text": "So do not fear, for I am with you; do not be dismayed, for I am your God. I will strengthen you and help you; I will uphold you with my righteous right hand.",
    "translation": "NIV"
  },
  {
    "id": 3,
    "reference": "Philippians 4:13",
    "text": "I can do all things through Christ who strengthens me.",
    "translation": "NIV"
  },
  {
    "id": 4,
    "reference": "Psalm 27:1",
    "text": "The Lord is my light and my salvation—whom shall I fear? The Lord is the stronghold of my life—of whom shall I be afraid?",
    "translation": "NIV"
  },
  {
    "id": 5,
    "reference": "2 Timothy 1:7",
    "text": "For God has not given us a spirit of fear, but of power and of love and of a sound mind.",
    "translation": "NIV"
  },
  {
    "id": 6,
    "reference": "Deuteronomy 31:6",
    "text": "Be strong and courageous. Do not be afraid or terrified because of them, for the Lord your God goes with you; he will never leave you nor forsake you.",
    "translation": "NIV"
  },
  {
    "id": 7,
    "reference": "Psalm 18:32",
    "text": "It is God who arms me with strength and keeps my way secure.",
    "translation": "NIV"
  },
  {
    "id": 8,
    "reference": "Isaiah 40:31",
    "text": "But those who hope in the Lord will renew their strength. They will soar on wings like eagles; they will run and not grow weary, they will walk and not be faint.",
    "translation": "NIV"
  },
  {
    "id": 9,
    "reference": "Ephesians 6:10",
    "text": "Finally, be strong in the Lord and in his mighty power.",
    "translation": "NIV"
  },
  {
    "id": 10,
    "reference": "1 Chronicles 16:11",
    "text": "Look to the Lord and his strength; seek his face always.",
    "translation": "NIV"
  },
  {
    "id": 11,
    "reference": "Psalm 46:1",
    "text": "God is our refuge and strength, an ever-present help in trouble.",
    "translation": "NIV"
  },
  {
    "id": 12,
    "reference": "Nahum 1:7",
    "text": "The Lord is good, a refuge in times of trouble. He cares for those who trust in him.",
    "translation": "NIV"
  },
  {
    "id": 13,
    "reference": "2 Corinthians 12:9",
    "text": "My grace is sufficient for you, for my power is made perfect in weakness.",
    "translation": "NIV"
  },
  {
    "id": 14,
    "reference": "Psalm 73:26",
    "text": "My flesh and my heart may fail, but God is the strength of my heart and my portion forever.",
    "translation": "NIV"
  },
  {
    "id": 15,
    "reference": "Isaiah 40:29",
    "text": "He gives strength to the weary and increases the power of the weak.",
    "translation": "NIV"
  },
  {
    "id": 16,
    "reference": "Psalm 28:7",
    "text": "The Lord is my strength and my shield; my heart trusts in him, and he helps me.",
    "translation": "NIV"
  },
  {
    "id": 17,
    "reference": "Habakkuk 3:19",
    "text": "The Sovereign Lord is my strength; he makes my feet like the feet of a deer, he enables me to tread on the heights.",
    "translation": "NIV"
  },
  {
    "id": 18,
    "reference": "Psalm 118:14",
    "text": "The Lord is my strength and my defense; he has become my salvation.",
    "translation": "NIV"
  },
  {
    "id": 19,
    "reference": "Exodus 15:2",
    "text": "The Lord is my strength and my song; he has given me victory.",
    "translation": "NIV"
  },
  {
    "id": 20,
    "reference": "Nehemiah 8:10",
    "text": "Do not grieve, for the joy of the Lord is your strength.",
    "translation": "NIV"
  },
  {
    "id": 21,
    "reference": "Proverbs 3:5-6",
    "text": "Trust in the Lord with all your heart and lean not on your own understanding; in all your ways submit to him, and he will make your paths straight.",
    "translation": "NIV"
  },
  {
    "id": 22,
    "reference": "Hebrews 11:1",
    "text": "Now faith is confidence in what we hope for and assurance about what we do not see.",
    "translation": "NIV"
  },
  {
    "id": 23,
    "reference": "Matthew 17:20",
    "text": "If you have faith as small as a mustard seed, you can say to this mountain, 'Move from here to there,' and it will move. Nothing will be impossible for you.",
    "translation": "NIV"
  },
  {
    "id": 24,
    "reference": "Mark 11:24",
    "text": "Therefore I tell you, whatever you ask for in prayer, believe that you have received it, and it will be yours.",
    "translation": "NIV"
  },
  {
    "id": 25,
    "reference": "Romans 10:17",
    "text": "Faith comes from hearing the message, and the message is heard through the word about Christ.",
    "translation": "NIV"
  },
  {
    "id": 26,
    "reference": "2 Corinthians 5:7",
    "text": "For we live by faith, not by sight.",
    "translation": "NIV"
  },
  {
    "id": 27,
    "reference": "Psalm 56:3",
    "text": "When I am afraid, I put my trust in you.",
    "translation": "NIV"
  },
  {
    "id": 28,
    "reference": "Psalm 37:5",
    "text": "Commit your way to the Lord; trust in him and he will do this.",
    "translation": "NIV"
  },
  {
    "id": 29,
    "reference": "James 1:6",
    "text": "But when you ask, you must believe and not doubt, because the one who doubts is like a wave of the sea, blown and tossed by the wind.",
    "translation": "NIV"
  },
  {
    "id": 30,
    "reference": "Psalm 125:1",
    "text": "Those who trust in the Lord are like Mount Zion, which cannot be shaken but endures forever.",
    "translation": "NIV"
  },
  {
    "id": 31,
    "reference": "Isaiah 26:3",
    "text": "You will keep in perfect peace those whose minds are steadfast, because they trust in you.",
    "translation": "NIV"
  },
  {
    "id": 32,
    "reference": "Psalm 91:2",
    "text": "I will say of the Lord, 'He is my refuge and my fortress, my God, in whom I trust.'",
    "translation": "NIV"
  },
  {
    "id": 33,
    "reference": "Romans 15:13",
    "text": "May the God of hope fill you with all joy and peace as you trust in him, so that you may overflow with hope by the power of the Holy Spirit.",
    "translation": "NIV"
  },
  {
    "id": 34,
    "reference": "Psalm 9:10",
    "text": "Those who know your name trust in you, for you, Lord, have never forsaken those who seek you.",
    "translation": "NIV"
  },
  {
    "id": 35,
    "reference": "Psalm 62:8",
    "text": "Trust in him at all times, you people; pour out your hearts to him, for God is our refuge.",
    "translation": "NIV"
  },
  {
    "id": 36,
    "reference": "Jeremiah 17:7",
    "text": "Blessed is the one who trusts in the Lord, whose confidence is in him.",
    "translation": "NIV"
  },
  {
    "id": 37,
    "reference": "Psalm 84:12",
    "text": "Lord Almighty, blessed is the one who trusts in you.",
    "translation": "NIV"
  },
  {
    "id": 38,
    "reference": "Psalm 115:11",
    "text": "You who fear him, trust in the Lord—he is their help and shield.",
    "translation": "NIV"
  },
  {
    "id": 39,
    "reference": "Psalm 40:4",
    "text": "Blessed is the one who trusts in the Lord, who does not look to the proud.",
    "translation": "NIV"
  },
  {
    "id": 40,
    "reference": "1 Peter 5:7",
    "text": "Cast all your anxiety on him because he cares for you.",
    "translation": "NIV"
  },
  {
    "id": 41,
    "reference": "Jeremiah 29:11",
    "text": "For I know the plans I have for you, declares the Lord, plans to prosper you and not to harm you, plans to give you hope and a future.",
    "translation": "NIV"
  },
  {
    "id": 42,
    "reference": "Romans 8:28",
    "text": "And we know that in all things God works for the good of those who love him, who have been called according to his purpose.",
    "translation": "NIV"
  },
  {
    "id": 43,
    "reference": "Psalm 23:1",
    "text": "The Lord is my shepherd, I lack nothing.",
    "translation": "NIV"
  },
  {
    "id": 44,
    "reference": "Matthew 11:28",
    "text": "Come to me, all you who are weary and burdened, and I will give you rest.",
    "translation": "NIV"
  },
  {
    "id": 45,
    "reference": "John 16:33",
    "text": "I have told you these things, so that in me you may have peace. In this world you will have trouble. But take heart! I have overcome the world.",
    "translation": "NIV"
  },
  {
    "id": 46,
    "reference": "Romans 8:38-39",
    "text": "For I am convinced that neither death nor life, neither angels nor demons, neither the present nor the future, nor any powers, neither height nor depth, nor anything else in all creation, will be able to separate us from the love of God.",
    "translation": "NIV"
  },
  {
    "id": 47,
    "reference": "Psalm 34:17",
    "text": "The righteous cry out, and the Lord hears them; he delivers them from all their troubles.",
    "translation": "NIV"
  },
  {
    "id": 48,
    "reference": "2 Corinthians 4:16",
    "text": "Therefore we do not lose heart. Though outwardly we are wasting away, yet inwardly we are being renewed day by day.",
    "translation": "NIV"
  },
  {
    "id": 49,
    "reference": "Psalm 30:5",
    "text": "Weeping may stay for the night, but rejoicing comes in the morning.",
    "translation": "NIV"
  },
  {
    "id": 50,
    "reference": "Isaiah 43:2",
    "text": "When you pass through the waters, I will be with you; and when you pass through the rivers, they will not sweep over you.",
    "translation": "NIV"
  },
  {
    "id": 51,
    "reference": "Psalm 147:3",
    "text": "He heals the brokenhearted and binds up their wounds.",
    "translation": "NIV"
  },
  {
    "id": 52,
    "reference": "Romans 12:12",
    "text": "Be joyful in hope, patient in affliction, faithful in prayer.",
    "translation": "NIV"
  },
  {
    "id": 53,
    "reference": "Lamentations 3:22-23",
    "text": "Because of the Lord's great love we are not consumed, for his compassions never fail. They are new every morning; great is your faithfulness.",
    "translation": "NIV"
  },
  {
    "id": 54,
    "reference": "Psalm 42:11",
    "text": "Why, my soul, are you downcast? Why so disturbed within me? Put your hope in God, for I will yet praise him, my Savior and my God.",
    "translation": "NIV"
  },
  {
    "id": 55,
    "reference": "1 Thessalonians 5:11",
    "text": "Therefore encourage one another and build each other up, just as in fact you are doing.",
    "translation": "NIV"
  },
  {
    "id": 56,
    "reference": "Psalm 121:1-2",
    "text": "I lift up my eyes to the mountains—where does my help come from? My help comes from the Lord, the Maker of heaven and earth.",
    "translation": "NIV"
  },
  {
    "id": 57,
    "reference": "Isaiah 40:28",
    "text": "Do you not know? Have you not heard? The Lord is the everlasting God, the Creator of the ends of the earth. He will not grow tired or weary.",
    "translation": "NIV"
  },
  {
    "id": 58,
    "reference": "Psalm 55:22",
    "text": "Cast your cares on the Lord and he will sustain you; he will never let the righteous be shaken.",
    "translation": "NIV"
  },
  {
    "id": 59,
    "reference": "John 14:27",
    "text": "Peace I leave with you; my peace I give you. I do not give to you as the world gives. Do not let your hearts be troubled and do not be afraid.",
    "translation": "NIV"
  },
  {
    "id": 60,
    "reference": "Psalm 16:8",
    "text": "I keep my eyes always on the Lord. With him at my right hand, I will not be shaken.",
    "translation": "NIV"
  },
  {
    "id": 61,
    "reference": "Philippians 4:6-7",
    "text": "Do not be anxious about anything, but in every situation, by prayer and petition, with thanksgiving, present your requests to God. And the peace of God, which transcends all understanding, will guard your hearts and your minds.",
    "translation": "NIV"
  },
  {
    "id": 62,
    "reference": "Matthew 6:34",
    "text": "Therefore do not worry about tomorrow, for tomorrow will worry about itself. Each day has enough trouble of its own.",
    "translation": "NIV"
  },
  {
    "id": 63,
    "reference": "Psalm 94:19",
    "text": "When anxiety was great within me, your consolation brought me joy.",
    "translation": "NIV"
  },
  {
    "id": 64,
    "reference": "2 Thessalonians 3:16",
    "text": "Now may the Lord of peace himself give you peace at all times and in every way.",
    "translation": "NIV"
  },
  {
    "id": 65,
    "reference": "Isaiah 26:4",
    "text": "Trust in the Lord forever, for the Lord, the Lord himself, is the Rock eternal.",
    "translation": "NIV"
  },
  {
    "id": 66,
    "reference": "Psalm 119:165",
    "text": "Great peace have those who love your law, and nothing can make them stumble.",
    "translation": "NIV"
  },
  {
    "id": 67,
    "reference": "Colossians 3:15",
    "text": "Let the peace of Christ rule in your hearts, since as members of one body you were called to peace.",
    "translation": "NIV"
  },
  {
    "id": 68,
    "reference": "Romans 8:6",
    "text": "The mind governed by the Spirit is life and peace.",
    "translation": "NIV"
  },
  {
    "id": 69,
    "reference": "Isaiah 32:17",
    "text": "The fruit of that righteousness will be peace; its effect will be quietness and confidence forever.",
    "translation": "NIV"
  },
  {
    "id": 70,
    "reference": "Psalm 29:11",
    "text": "The Lord gives strength to his people; the Lord blesses his people with peace.",
    "translation": "NIV"
  },
  {
    "id": 71,
    "reference": "John 14:1",
    "text": "Do not let your hearts be troubled. You believe in God; believe also in me.",
    "translation": "NIV"
  },
  {
    "id": 72,
    "reference": "2 Corinthians 1:3-4",
    "text": "Praise be to the God and Father of our Lord Jesus Christ, the Father of compassion and the God of all comfort, who comforts us in all our troubles.",
    "translation": "NIV"
  },
  {
    "id": 73,
    "reference": "Psalm 23:4",
    "text": "Even though I walk through the darkest valley, I will fear no evil, for you are with me; your rod and your staff, they comfort me.",
    "translation": "NIV"
  },
  {
    "id": 74,
    "reference": "Matthew 5:4",
    "text": "Blessed are those who mourn, for they will be comforted.",
    "translation": "NIV"
  },
  {
    "id": 75,
    "reference": "Isaiah 49:13",
    "text": "For the Lord comforts his people and will have compassion on his afflicted ones.",
    "translation": "NIV"
  },
  {
    "id": 76,
    "reference": "Psalm 86:17",
    "text": "Give me a sign of your goodness, that my enemies may see it and be put to shame, for you, Lord, have helped me and comforted me.",
    "translation": "NIV"
  },
  {
    "id": 77,
    "reference": "Isaiah 51:12",
    "text": "I, even I, am he who comforts you. Who are you that you fear mere mortals?",
    "translation": "NIV"
  },
  {
    "id": 78,
    "reference": "Psalm 71:21",
    "text": "You will increase my honor and comfort me once more.",
    "translation": "NIV"
  },
  {
    "id": 79,
    "reference": "Isaiah 66:13",
    "text": "As a mother comforts her child, so will I comfort you.",
    "translation": "NIV"
  },
  {
    "id": 80,
    "reference": "Romans 15:4",
    "text": "For everything that was written in the past was written to teach us, so that through the endurance taught in the Scriptures and the encouragement they provide we might have hope.",
    "translation": "NIV"
  },
  {
    "id": 81,
    "reference": "1 Corinthians 15:57",
    "text": "But thanks be to God! He gives us the victory through our Lord Jesus Christ.",
    "translation": "NIV"
  },
  {
    "id": 82,
    "reference": "Romans 8:37",
    "text": "No, in all these things we are more than conquerors through him who loved us.",
    "translation": "NIV"
  },
  {
    "id": 83,
    "reference": "1 John 5:4",
    "text": "For everyone born of God overcomes the world. This is the victory that has overcome the world, even our faith.",
    "translation": "NIV"
  },
  {
    "id": 84,
    "reference": "2 Corinthians 2:14",
    "text": "But thanks be to God, who always leads us as captives in Christ's triumphal procession.",
    "translation": "NIV"
  },
  {
    "id": 85,
    "reference": "Philippians 1:6",
    "text": "Being confident of this, that he who began a good work in you will carry it on to completion until the day of Christ Jesus.",
    "translation": "NIV"
  },
  {
    "id": 86,
    "reference": "Ephesians 2:10",
    "text": "For we are God's handiwork, created in Christ Jesus to do good works, which God prepared in advance for us to do.",
    "translation": "NIV"
  },
  {
    "id": 87,
    "reference": "Psalm 138:8",
    "text": "The Lord will vindicate me; your love, Lord, endures forever—do not abandon the works of your hands.",
    "translation": "NIV"
  },
  {
    "id": 88,
    "reference": "Proverbs 19:21",
    "text": "Many are the plans in a person's heart, but it is the Lord's purpose that prevails.",
    "translation": "NIV"
  },
  {
    "id": 89,
    "reference": "Romans 8:31",
    "text": "What, then, shall we say in response to these things? If God is for us, who can be against us?",
    "translation": "NIV"
  },
  {
    "id": 90,
    "reference": "Psalm 20:4",
    "text": "May he give you the desire of your heart and make all your plans succeed.",
    "translation": "NIV"
  },
  {
    "id": 91,
    "reference": "Isaiah 54:17",
    "text": "No weapon forged against you will prevail, and you will refute every tongue that accuses you.",
    "translation": "NIV"
  },
  {
    "id": 92,
    "reference": "Deuteronomy 28:13",
    "text": "The Lord will make you the head, not the tail. If you pay attention to the commands of the Lord your God.",
    "translation": "NIV"
  },
  {
    "id": 93,
    "reference": "Psalm 118:6",
    "text": "The Lord is with me; I will not be afraid. What can mere mortals do to me?",
    "translation": "NIV"
  },
  {
    "id": 94,
    "reference": "Galatians 6:9",
    "text": "Let us not become weary in doing good, for at the proper time we will reap a harvest if we do not give up.",
    "translation": "NIV"
  },
  {
    "id": 95,
    "reference": "1 Peter 2:9",
    "text": "But you are a chosen people, a royal priesthood, a holy nation, God's special possession.",
    "translation": "NIV"
  },
  {
    "id": 96,
    "reference": "2 Timothy 4:7",
    "text": "I have fought the good fight, I have finished the race, I have kept the faith.",
    "translation": "NIV"
  },
  {
    "id": 97,
    "reference": "Psalm 37:4",
    "text": "Take delight in the Lord, and he will give you the desires of your heart.",
    "translation": "NIV"
  },
  {
    "id": 98,
    "reference": "Ecclesiastes 3:1",
    "text": "There is a time for everything, and a season for every activity under the heavens.",
    "translation": "NIV"
  },
  {
    "id": 99,
    "reference": "Psalm 90:17",
    "text": "May the favor of the Lord our God rest on us; establish the work of our hands for us.",
    "translation": "NIV"
  },
  {
    "id": 100,
    "reference": "3 John 1:2",
    "text": "Dear friend, I pray that you may enjoy good health and that all may go well with you, even as your soul is getting along well.",
    "translation": "NIV"
  },
  {
    "id": 101,
    "reference": "John 3:16",
    "text": "“For God so loved the world, that he gave his only Son, that whoever believes in him should not perish but have eternal life.",
    "translation": "ESV"
  },
  {
    "id": 102,
    "reference": "Romans 3:23",
    "text": "for all have sinned and fall short of the glory of God,",
    "translation": "ESV"
  },
  {
    "id": 103,
    "reference": "Romans 6:23",
    "text": "For the wages of sin is death, but the free gift of God is eternal life in Christ Jesus our Lord.",
    "translation": "ESV"
  },
  {
    "id": 104,
    "reference": "Romans 5:8",
    "text": "but God shows his love for us in that while we were still sinners, Christ died for us.",
    "translation": "ESV"
  },
  {
    "id": 105,
    "reference": "Romans 10:9",
    "text": "because, if you confess with your mouth that Jesus is Lord and believe in your heart that God raised him from the dead, you will be saved.",
    "translation": "ESV"
  },
  {
    "id": 106,
    "reference": "Romans 10:13",
    "text": "For “everyone who calls on the name of the Lord will be saved.”",
    "translation": "ESV"
  },
  {
    "id": 107,
    "reference": "John 14:6",
    "text": "Jesus said to him, “I am the way, and the truth, and the life. No one comes to the Father except through me.",
    "translation": "ESV"
  },
  {
    "id": 108,
    "reference": "Acts 4:12",
    "text": "And there is salvation in no one else, for there is no other name under heaven given among men by which we must be saved.”",
    "translation": "ESV"
  },
  {
    "id": 109,
    "reference": "1 John 1:9",
    "text": "If we confess our sins, he is faithful and just to forgive us our sins and to cleanse us from all unrighteousness.",
    "translation": "ESV"
  },
  {
    "id": 110,
    "reference": "John 1:12",
    "text": "But to all who did receive him, who believed in his name, he gave the right to become children of God,",
    "translation": "ESV"
  },
  {
    "id": 111,
    "reference": "Psalm 118:24",
    "text": "This is the day that the Lord has made;\n    let us rejoice and be glad in it.",
    "translation": "ESV"
  },
  {
    "id": 112,
    "reference": "Psalm 119:105",
    "text": "Your word is a lamp to my feet\n    and a light to my path.",
    "translation": "ESV"
  },
  {
    "id": 113,
    "reference": "Proverbs 3:5",
    "text": "Trust in the Lord with all your heart,\n    and do not lean on your own understanding.",
    "translation": "ESV"
  },
  {
    "id": 114,
    "reference": "Proverbs 3:6",
    "text": "In all your ways acknowledge him,\n    and he will make straight your paths.",
    "translation": "ESV"
  },
  {
    "id": 115,
    "reference": "Genesis 1:1",
    "text": "In the beginning, God created the heavens and the earth.",
    "translation": "ESV"
  },
  {
    "id": 116,
    "reference": "John 11:35",
    "text": "Jesus wept.",
    "translation": "ESV"
  },
  {
    "id": 117,
    "reference": "1 Thessalonians 5:16",
    "text": "Rejoice always,",
    "translation": "ESV"
  },
  {
    "id": 118,
    "reference": "1 Thessalonians 5:17",
    "text": "pray without ceasing,",
    "translation": "ESV"
  },
  {
    "id": 119,
    "reference": "1 Thessalonians 5:18",
    "text": "give thanks in all circumstances; for this is the will of God in Christ Jesus for you.",
    "translation": "ESV"
  },
  {
    "id": 120,
    "reference": "Philippians 4:6",
    "text": "do not be anxious about anything, but in everything by prayer and supplication with thanksgiving let your requests be made known to God.",
    "translation": "ESV"
  },
  {
    "id": 121,
    "reference": "Philippians 4:7",
    "text": "And the peace of God, which surpasses all understanding, will guard your hearts and your minds in Christ Jesus.",
    "translation": "ESV"
  },
  {
    "id": 122,
    "reference": "1 John 4:19",
    "text": "We love because he first loved us.",
    "translation": "ESV"
  },
  {
    "id": 123,
    "reference": "1 John 4:8",
    "text": "Anyone who does not love does not know God, because God is love.",
    "translation": "ESV"
  },
  {
    "id": 124,
    "reference": "John 13:34",
    "text": "A new commandment I give to you, that you love one another: just as I have loved you, you also are to love one another.",
    "translation": "ESV"
  },
  {
    "id": 125,
    "reference": "John 15:12",
    "text": "“This is my commandment, that you love one another as I have loved you.",
    "translation": "ESV"
  },
  {
    "id": 126,
    "reference": "Matthew 22:37",
    "text": "And he said to him, “You shall love the Lord your God with all your heart and with all your soul and with all your mind.",
    "translation": "ESV"
  },
  {
    "id": 127,
    "reference": "Matthew 22:39",
    "text": "And a second is like it: You shall love your neighbor as yourself.",
    "translation": "ESV"
  },
  {
    "id": 128,
    "reference": "Matthew 7:7",
    "text": "“Ask, and it will be given to you; seek, and you will find; knock, and it will be opened to you.",
    "translation": "ESV"
  },
  {
    "id": 129,
    "reference": "Matthew 21:22",
    "text": "And whatever you ask in prayer, you will receive, if you have faith.”",
    "translation": "ESV"
  },
  {
    "id": 130,
    "reference": "James 1:5",
    "text": "If any of you lacks wisdom, let him ask God, who gives generously to all without reproach, and it will be given him.",
    "translation": "ESV"
  },
  {
    "id": 131,
    "reference": "James 5:16",
    "text": "Therefore, confess your sins to one another and pray for one another, that you may be healed. The prayer of a righteous person has great power as it is working.",
    "translation": "ESV"
  },
  {
    "id": 132,
    "reference": "Hebrews 11:6",
    "text": "And without faith it is impossible to please him, for whoever would draw near to God must believe that he exists and that he rewards those who seek him.",
    "translation": "ESV"
  },
  {
    "id": 133,
    "reference": "Matthew 28:19",
    "text": "Go therefore and make disciples of all nations, baptizing them in the name of the Father and of the Son and of the Holy Spirit,",
    "translation": "ESV"
  },
  {
    "id": 134,
    "reference": "Matthew 28:20",
    "text": "teaching them to observe all that I have commanded you. And behold, I am with you always, to the end of the age.”",
    "translation": "ESV"
  },
  {
    "id": 135,
    "reference": "2 Corinthians 5:17",
    "text": "Therefore, if anyone is in Christ, he is a new creation. The old has passed away; behold, the new has come.",
    "translation": "ESV"
  },
  {
    "id": 136,
    "reference": "Galatians 2:20",
    "text": "I have been crucified with Christ. It is no longer I who live, but Christ who lives in me. And the life I now live in the flesh I live by faith in the Son of God, who loved me and gave himself for me.",
    "translation": "ESV"
  },
  {
    "id": 137,
    "reference": "1 Corinthians 10:13",
    "text": "No temptation has overtaken you that is not common to man. God is faithful, and he will not let you be tempted beyond your ability, but with the temptation he will also provide the way of escape, that you may be able to endure it.",
    "translation": "ESV"
  },
  {
    "id": 138,
    "reference": "Matthew 6:33",
    "text": "But seek first the kingdom of God and his righteousness, and all these things will be added to you.",
    "translation": "ESV"
  },
  {
    "id": 139,
    "reference": "Proverbs 16:3",
    "text": "Commit your work to the Lord,\n    and your plans will be established.",
    "translation": "ESV"
  },
  {
    "id": 140,
    "reference": "Romans 8:1",
    "text": "There is therefore now no condemnation for those who are in Christ Jesus.",
    "translation": "ESV"
  },
  {
    "id": 141,
    "reference": "Romans 12:1",
    "text": "I appeal to you therefore, brothers, by the mercies of God, to present your bodies as a living sacrifice, holy and acceptable to God, which is your spiritual worship.",
    "translation": "ESV"
  },
  {
    "id": 142,
    "reference": "Romans 12:2",
    "text": "Do not be conformed to this world, but be transformed by the renewal of your mind, that by testing you may discern what is the will of God, what is good and acceptable and perfect.",
    "translation": "ESV"
  },
  {
    "id": 143,
    "reference": "Ephesians 6:11",
    "text": "Put on the whole armor of God, that you may be able to stand against the schemes of the devil.",
    "translation": "ESV"
  },
  {
    "id": 144,
    "reference": "Colossians 3:23",
    "text": "Whatever you do, work heartily, as for the Lord and not for men,",
    "translation": "ESV"
  },
  {
    "id": 145,
    "reference": "2 Corinthians 5:21",
    "text": "For our sake he made him to be sin who knew no sin, so that in him we might become the righteousness of God.",
    "translation": "ESV"
  },
  {
    "id": 146,
    "reference": "James 1:22",
    "text": "But be doers of the word, and not hearers only, deceiving yourselves.",
    "translation": "ESV"
  },
  {
    "id": 147,
    "reference": "James 4:7",
    "text": "Submit yourselves therefore to God. Resist the devil, and he will flee from you.",
    "translation": "ESV"
  },
  {
    "id": 148,
    "reference": "James 4:8",
    "text": "Draw near to God, and he will draw near to you. Cleanse your hands, you sinners, and purify your hearts, you double-minded.",
    "translation": "ESV"
  },
  {
    "id": 149,
    "reference": "1 Peter 3:15",
    "text": "but in your hearts honor Christ the Lord as holy, always being prepared to make a defense to anyone who asks you for a reason for the hope that is in you; yet do it with gentleness and respect,",
    "translation": "ESV"
  },
  {
    "id": 150,
    "reference": "2 Peter 3:9",
    "text": "The Lord is not slow to fulfill his promise as some count slowness, but is patient toward you, not wishing that any should perish, but that all should reach repentance.",
    "translation": "ESV"
  },
  {
    "id": 151,
    "reference": "1 John 4:4",
    "text": "Little children, you are from God and have overcome them, for he who is in you is greater than he who is in the world.",
    "translation": "ESV"
  },
  {
    "id": 152,
    "reference": "Ephesians 6:12",
    "text": "For we do not wrestle against flesh and blood, but against the rulers, against the authorities, against the cosmic powers over this present darkness, against the spiritual forces of evil in the heavenly places.",
    "translation": "ESV"
  },
  {
    "id": 153,
    "reference": "Ephesians 6:13",
    "text": "Therefore take up the whole armor of God, that you may be able to withstand in the evil day, and having done all, to stand firm.",
    "translation": "ESV"
  },
  {
    "id": 154,
    "reference": "Proverbs 9:10",
    "text": "The fear of the Lord is the beginning of wisdom,\n    and the knowledge of the Holy One is insight.",
    "translation": "ESV"
  },
  {
    "id": 155,
    "reference": "Proverbs 14:12",
    "text": "There is a way that seems right to a man,\n    but its end is the way to death.",
    "translation": "ESV"
  },
  {
    "id": 156,
    "reference": "Proverbs 16:18",
    "text": "Pride goes before destruction,\n    and a haughty spirit before a fall.",
    "translation": "ESV"
  },
  {
    "id": 157,
    "reference": "Proverbs 18:10",
    "text": "The name of the Lord is a strong tower;\n    the righteous man runs into it and is safe.",
    "translation": "ESV"
  },
  {
    "id": 158,
    "reference": "Proverbs 22:6",
    "text": "Train up a child in the way he should go;\n    even when he is old he will not depart from it.",
    "translation": "ESV"
  },
  {
    "id": 159,
    "reference": "Proverbs 27:17",
    "text": "Iron sharpens iron,\n    and one man sharpens another.",
    "translation": "ESV"
  },
  {
    "id": 160,
    "reference": "Ecclesiastes 12:13",
    "text": "The end of the matter; all has been heard. Fear God and keep his commandments, for this is the whole duty of man.",
    "translation": "ESV"
  },
  {
    "id": 161,
    "reference": "Isaiah 53:5",
    "text": "But he was pierced for our transgressions;\n    he was crushed for our iniquities;\nupon him was the chastisement that brought us peace,\n    and with his wounds we are healed.",
    "translation": "ESV"
  },
  {
    "id": 162,
    "reference": "Isaiah 53:6",
    "text": "All we like sheep have gone astray;\n    we have turned—every one—to his own way;\nand the Lord has laid on him\n    the iniquity of us all.",
    "translation": "ESV"
  },
  {
    "id": 163,
    "reference": "Isaiah 9:6",
    "text": "For to us a child is born,\n    to us a son is given;\nand the government shall be upon his shoulder,\n    and his name shall be called\nWonderful Counselor, Mighty God,\n    Everlasting Father, Prince of Peace.",
    "translation": "ESV"
  },
  {
    "id": 164,
    "reference": "Micah 5:2",
    "text": "But you, O Bethlehem Ephrathah,\n    who are too little to be among the clans of Judah,\nfrom you shall come forth for me\n    one who is to be ruler in Israel,\nwhose coming forth is from of old,\n    from ancient days.",
    "translation": "ESV"
  },
  {
    "id": 165,
    "reference": "Psalm 22:1",
    "text": "My God, my God, why have you forsaken me?\n    Why are you so far from saving me, from the words of my groaning?",
    "translation": "ESV"
  },
  {
    "id": 166,
    "reference": "Matthew 5:14",
    "text": "“You are the light of the world. A city set on a hill cannot be hidden.",
    "translation": "ESV"
  },
  {
    "id": 167,
    "reference": "Matthew 5:16",
    "text": "In the same way, let your light shine before others, so that they may see your good works and give glory to your Father who is in heaven.",
    "translation": "ESV"
  },
  {
    "id": 168,
    "reference": "Matthew 6:24",
    "text": "“No one can serve two masters, for either he will hate the one and love the other, or he will be devoted to the one and despise the other. You cannot serve God and money.",
    "translation": "ESV"
  },
  {
    "id": 169,
    "reference": "Matthew 7:12",
    "text": "“So whatever you wish that others would do to you, do also to them, for this is the Law and the Prophets.",
    "translation": "ESV"
  },
  {
    "id": 170,
    "reference": "Luke 6:27",
    "text": "“But I say to you who hear, Love your enemies, do good to those who hate you,",
    "translation": "ESV"
  },
  {
    "id": 171,
    "reference": "Luke 6:31",
    "text": "And as you wish that others would do to you, do so to them.",
    "translation": "ESV"
  },
  {
    "id": 172,
    "reference": "John 3:3",
    "text": "Jesus answered him, “Truly, truly, I say to you, unless one is born again he cannot see the kingdom of God.”",
    "translation": "ESV"
  },
  {
    "id": 173,
    "reference": "John 8:32",
    "text": "and you will know the truth, and the truth will set you free.”",
    "translation": "ESV"
  },
  {
    "id": 174,
    "reference": "John 10:10",
    "text": "The thief comes only to steal and kill and destroy. I came that they may have life and have it abundantly.",
    "translation": "ESV"
  },
  {
    "id": 175,
    "reference": "John 15:5",
    "text": "I am the vine; you are the branches. Whoever abides in me and I in him, he it is that bears much fruit, for apart from me you can do nothing.",
    "translation": "ESV"
  },
  {
    "id": 176,
    "reference": "Acts 1:8",
    "text": "But you will receive power when the Holy Spirit has come upon you, and you will be my witnesses in Jerusalem and in all Judea and Samaria, and to the end of the earth.”",
    "translation": "ESV"
  },
  {
    "id": 177,
    "reference": "Acts 16:31",
    "text": "And they said, “Believe in the Lord Jesus, and you will be saved, you and your household.”",
    "translation": "ESV"
  },
  {
    "id": 178,
    "reference": "1 Corinthians 15:58",
    "text": "Therefore, my beloved brothers, be steadfast, immovable, always abounding in the work of the Lord, knowing that in the Lord your labor is not in vain.",
    "translation": "ESV"
  },
  {
    "id": 179,
    "reference": "2 Timothy 2:15",
    "text": "Do your best to present yourself to God as one approved, a worker who has no need to be ashamed, rightly handling the word of truth.",
    "translation": "ESV"
  },
  {
    "id": 180,
    "reference": "2 Timothy 3:16",
    "text": "All Scripture is breathed out by God and profitable for teaching, for reproof, for correction, and for training in righteousness,",
    "translation": "ESV"
  },
  {
    "id": 181,
    "reference": "Titus 3:5",
    "text": "he saved us, not because of works done by us in righteousness, but according to his own mercy, by the washing of regeneration and renewal of the Holy Spirit,",
    "translation": "ESV"
  },
  {
    "id": 182,
    "reference": "Hebrews 12:1",
    "text": "Therefore, since we are surrounded by so great a cloud of witnesses, let us also lay aside every weight, and sin which clings so closely, and let us run with endurance the race that is set before us,",
    "translation": "ESV"
  },
  {
    "id": 183,
    "reference": "Hebrews 12:2",
    "text": "looking to Jesus, the founder and perfecter of our faith, who for the joy that was set before him endured the cross, despising the shame, and is seated at the right hand of the throne of God.",
    "translation": "ESV"
  },
  {
    "id": 184,
    "reference": "Hebrews 13:8",
    "text": "Jesus Christ is the same yesterday and today and forever.",
    "translation": "ESV"
  },
  {
    "id": 185,
    "reference": "Psalm 19:14",
    "text": "Let the words of my mouth and the meditation of my heart\n    be acceptable in your sight,\n    O Lord, my rock and my redeemer.",
    "translation": "ESV"
  },
  {
    "id": 186,
    "reference": "Psalm 34:8",
    "text": "Oh, taste and see that the Lord is good!\n    Blessed is the man who takes refuge in him!",
    "translation": "ESV"
  },
  {
    "id": 187,
    "reference": "Psalm 51:10",
    "text": "Create in me a clean heart, O God,\n    and renew a right spirit within me.",
    "translation": "ESV"
  },
  {
    "id": 188,
    "reference": "Psalm 100:4",
    "text": "Enter his gates with thanksgiving,\n    and his courts with praise!\n    Give thanks to him; bless his name!",
    "translation": "ESV"
  },
  {
    "id": 189,
    "reference": "Psalm 103:12",
    "text": "as far as the east is from the west,\n    so far does he remove our transgressions from us.",
    "translation": "ESV"
  },
  {
    "id": 190,
    "reference": "Psalm 139:14",
    "text": "I praise you, for I am fearfully and wonderfully made.\nWonderful are your works;\n    my soul knows it very well.",
    "translation": "ESV"
  },
  {
    "id": 191,
    "reference": "1 Corinthians 1:18",
    "text": "For the word of the cross is folly to those who are perishing, but to us who are being saved it is the power of God.",
    "translation": "ESV"
  },
  {
    "id": 192,
    "reference": "1 Corinthians 3:16",
    "text": "Do you not know that you are God's temple and that God's Spirit dwells in you?",
    "translation": "ESV"
  },
  {
    "id": 193,
    "reference": "2 Corinthians 6:14",
    "text": "Do not be unequally yoked with unbelievers. For what partnership has righteousness with lawlessness? Or what fellowship has light with darkness?",
    "translation": "ESV"
  },
  {
    "id": 194,
    "reference": "Hebrews 4:12",
    "text": "For the word of God is living and active, sharper than any two-edged sword, piercing to the division of soul and of spirit, of joints and of marrow, and discerning the thoughts and intentions of the heart.",
    "translation": "ESV"
  },
  {
    "id": 195,
    "reference": "Hebrews 11:3",
    "text": "By faith we understand that the universe was created by the word of God, so that what is seen was not made out of things that are visible.",
    "translation": "ESV"
  },
  {
    "id": 196,
    "reference": "James 1:12",
    "text": "Blessed is the man who remains steadfast under trial, for when he has stood the test he will receive the crown of life, which God has promised to those who love him.",
    "translation": "ESV"
  },
  {
    "id": 197,
    "reference": "James 1:17",
    "text": "Every good gift and every perfect gift is from above, coming down from the Father of lights, with whom there is no variation or shadow due to change.",
    "translation": "ESV"
  },
  {
    "id": 198,
    "reference": "James 2:17",
    "text": "So also faith by itself, if it does not have works, is dead.",
    "translation": "ESV"
  },
  {
    "id": 199,
    "reference": "1 Peter 2:24",
    "text": "He himself bore our sins in his body on the tree, that we might die to sin and live to righteousness. By his wounds you have been healed.",
    "translation": "ESV"
  },
  {
    "id": 200,
    "reference": "1 Peter 4:10",
    "text": "As each has received a gift, use it to serve one another, as good stewards of God's varied grace:",
    "translation": "ESV"
  },
  {
    "id": 201,
    "reference": "1 John 1:7",
    "text": "But if we walk in the light, as he is in the light, we have fellowship with one another, and the blood of Jesus his Son cleanses us from all sin.",
    "translation": "ESV"
  },
  {
    "id": 202,
    "reference": "1 John 3:1",
    "text": "See what kind of love the Father has given to us, that we should be called children of God; and so we are. The reason why the world does not know us is that it did not know him.",
    "translation": "ESV"
  },
  {
    "id": 203,
    "reference": "1 John 3:16",
    "text": "By this we know love, that he laid down his life for us, and we ought to lay down our lives for the brothers.",
    "translation": "ESV"
  },
  {
    "id": 204,
    "reference": "1 John 3:18",
    "text": "Little children, let us not love in word or talk but in deed and in truth.",
    "translation": "ESV"
  },
  {
    "id": 205,
    "reference": "Revelation 1:8",
    "text": "“I am the Alpha and the Omega,” says the Lord God, “who is and who was and who is to come, the Almighty.”",
    "translation": "ESV"
  },
  {
    "id": 206,
    "reference": "Revelation 3:20",
    "text": "Behold, I stand at the door and knock. If anyone hears my voice and opens the door, I will come in to him and eat with him, and he with me.",
    "translation": "ESV"
  },
  {
    "id": 207,
    "reference": "Revelation 21:4",
    "text": "He will wipe away every tear from their eyes, and death shall be no more, neither shall there be mourning, nor crying, nor pain anymore, for the former things have passed away.”",
    "translation": "ESV"
  },
  {
    "id": 208,
    "reference": "Revelation 22:13",
    "text": "I am the Alpha and the Omega, the first and the last, the beginning and the end.”",
    "translation": "ESV"
  },
  {
    "id": 209,
    "reference": "Psalm 16:11",
    "text": "You make known to me the path of life;\n    in your presence there is fullness of joy;\n    at your right hand are pleasures forevermore.",
    "translation": "ESV"
  },
  {
    "id": 210,
    "reference": "Psalm 32:8",
    "text": "I will instruct you and teach you in the way you should go;\n    I will counsel you with my eye upon you.",
    "translation": "ESV"
  },
  {
    "id": 211,
    "reference": "Psalm 90:12",
    "text": "So teach us to number our days\n    that we may get a heart of wisdom.",
    "translation": "ESV"
  },
  {
    "id": 212,
    "reference": "Psalm 127:1",
    "text": "Unless the Lord builds the house,\n    those who build it labor in vain.\nUnless the Lord watches over the city,\n    the watchman stays awake in vain.",
    "translation": "ESV"
  },
  {
    "id": 213,
    "reference": "Proverbs 1:7",
    "text": "The fear of the Lord is the beginning of knowledge;\n    fools despise wisdom and instruction.",
    "translation": "ESV"
  },
  {
    "id": 214,
    "reference": "Proverbs 4:23",
    "text": "Keep your heart with all vigilance,\n    for from it flow the springs of life.",
    "translation": "ESV"
  },
  {
    "id": 215,
    "reference": "Proverbs 13:20",
    "text": "Whoever walks with the wise becomes wise,\n    but the companion of fools will suffer harm.",
    "translation": "ESV"
  },
  {
    "id": 216,
    "reference": "Proverbs 15:1",
    "text": "A soft answer turns away wrath,\n    but a harsh word stirs up anger.",
    "translation": "ESV"
  },
  {
    "id": 217,
    "reference": "Proverbs 29:18",
    "text": "Where there is no prophetic vision the people cast off restraint,\n    but blessed is he who keeps the law.",
    "translation": "ESV"
  },
  {
    "id": 218,
    "reference": "Isaiah 6:8",
    "text": "And I heard the voice of the Lord saying, “Whom shall I send, and who will go for us?” Then I said, “Here I am! Send me.”",
    "translation": "ESV"
  },
  {
    "id": 219,
    "reference": "Isaiah 7:14",
    "text": "Therefore the Lord himself will give you a sign. Behold, the virgin shall conceive and bear a son, and shall call his name Immanuel.",
    "translation": "ESV"
  },
  {
    "id": 220,
    "reference": "Isaiah 64:6",
    "text": "We have all become like one who is unclean,\n    and all our righteous deeds are like a polluted garment.\nWe all fade like a leaf,\n    and our iniquities, like the wind, take us away.",
    "translation": "ESV"
  },
  {
    "id": 221,
    "reference": "Jeremiah 1:5",
    "text": "“Before I formed you in the womb I knew you,\nand before you were born I consecrated you;\nI appointed you a prophet to the nations.”",
    "translation": "ESV"
  },
  {
    "id": 222,
    "reference": "Jeremiah 17:9",
    "text": "The heart is deceitful above all things,\n    and desperately sick;\n    who can understand it?",
    "translation": "ESV"
  },
  {
    "id": 223,
    "reference": "Jeremiah 31:3",
    "text": "the Lord appeared to him from far away.\nI have loved you with an everlasting love;\n    therefore I have continued my faithfulness to you.",
    "translation": "ESV"
  },
  {
    "id": 224,
    "reference": "Jeremiah 33:3",
    "text": "Call to me and I will answer you, and will tell you great and hidden things that you have not known.",
    "translation": "ESV"
  },
  {
    "id": 225,
    "reference": "Ezekiel 36:26",
    "text": "And I will give you a new heart, and a new spirit I will put within you. And I will remove the heart of stone from your flesh and give you a heart of flesh.",
    "translation": "ESV"
  },
  {
    "id": 226,
    "reference": "Daniel 12:3",
    "text": "And those who are wise shall shine like the brightness of the sky above; and those who turn many to righteousness, like the stars forever and ever.",
    "translation": "ESV"
  },
  {
    "id": 227,
    "reference": "Hosea 6:3",
    "text": "Let us know; let us press on to know the Lord;\n    his going out is sure as the dawn;\nhe will come to us as the showers,\n    as the spring rains that water the earth.”",
    "translation": "ESV"
  },
  {
    "id": 228,
    "reference": "Joel 2:28",
    "text": "“And it shall come to pass afterward,\n    that I will pour out my Spirit on all flesh;\nyour sons and your daughters shall prophesy,\n    your old men shall dream dreams,\n    and your young men shall see visions.",
    "translation": "ESV"
  },
  {
    "id": 229,
    "reference": "Micah 6:8",
    "text": "He has told you, O man, what is good;\n    and what does the Lord require of you\nbut to do justice, and to love kindness,\n    and to walk humbly with your God?",
    "translation": "ESV"
  },
  {
    "id": 230,
    "reference": "Habakkuk 2:14",
    "text": "For the earth will be filled\n    with the knowledge of the glory of the Lord\n    as the waters cover the sea.",
    "translation": "ESV"
  },
  {
    "id": 231,
    "reference": "Zephaniah 3:17",
    "text": "The Lord your God is in your midst,\n    a mighty one who will save;\nhe will rejoice over you with gladness;\n    he will quiet you by his love;\nhe will exult over you with loud singing.",
    "translation": "ESV"
  },
  {
    "id": 232,
    "reference": "Zechariah 4:6",
    "text": "Then he said to me, “This is the word of the Lord to Zerubbabel: Not by might, nor by power, but by my Spirit, says the Lord of hosts.",
    "translation": "ESV"
  },
  {
    "id": 233,
    "reference": "Malachi 3:10",
    "text": "Bring the full tithe into the storehouse, that there may be food in my house. And thereby put me to the test, says the Lord of hosts, if I will not open the windows of heaven for you and pour down for you a blessing until there is no more need.",
    "translation": "ESV"
  },
  {
    "id": 234,
    "reference": "Genesis 1:31",
    "text": "And God saw everything that he had made, and behold, it was very good. And there was evening and there was morning, the sixth day.",
    "translation": "ESV"
  },
  {
    "id": 235,
    "reference": "Genesis 2:7",
    "text": "then the Lord God formed the man of dust from the ground and breathed into his nostrils the breath of life, and the man became a living creature.",
    "translation": "ESV"
  },
  {
    "id": 236,
    "reference": "Genesis 2:18",
    "text": "Then the Lord God said, “It is not good that the man should be alone; I will make him a helper fit for him.”",
    "translation": "ESV"
  },
  {
    "id": 237,
    "reference": "Genesis 2:24",
    "text": "Therefore a man shall leave his father and his mother and hold fast to his wife, and they shall become one flesh.",
    "translation": "ESV"
  },
  {
    "id": 238,
    "reference": "Genesis 3:15",
    "text": "I will put enmity between you and the woman,\n    and between your offspring and her offspring;\nhe shall bruise your head,\n    and you shall bruise his heel.”",
    "translation": "ESV"
  },
  {
    "id": 239,
    "reference": "Genesis 6:5",
    "text": "The Lord saw that the wickedness of man was great in the earth, and that every intention of the thoughts of his heart was only evil continually.",
    "translation": "ESV"
  },
  {
    "id": 240,
    "reference": "Genesis 15:6",
    "text": "And he believed the Lord, and he counted it to him as righteousness.",
    "translation": "ESV"
  },
  {
    "id": 241,
    "reference": "Genesis 22:14",
    "text": "So Abraham called the name of that place, “The Lord will provide”; as it is said to this day, “On the mount of the Lord it shall be provided.”",
    "translation": "ESV"
  },
  {
    "id": 242,
    "reference": "Genesis 28:15",
    "text": "Behold, I am with you and will keep you wherever you go, and will bring you back to this land. For I will not leave you until I have done what I have promised you.”",
    "translation": "ESV"
  },
  {
    "id": 243,
    "reference": "Genesis 50:20",
    "text": "As for you, you meant evil against me, but God meant it for good, to bring it about that many people should be kept alive, as they are today.",
    "translation": "ESV"
  },
  {
    "id": 244,
    "reference": "Exodus 3:14",
    "text": "God said to Moses, “I am who I am.” And he said, “Say this to the people of Israel: ‘I am has sent me to you.’”",
    "translation": "ESV"
  },
  {
    "id": 245,
    "reference": "Exodus 12:13",
    "text": "The blood shall be a sign for you, on the houses where you are. And when I see the blood, I will pass over you, and no plague will befall you to destroy you, when I strike the land of Egypt.",
    "translation": "ESV"
  },
  {
    "id": 246,
    "reference": "Exodus 14:14",
    "text": "The Lord will fight for you, and you have only to be silent.”",
    "translation": "ESV"
  },
  {
    "id": 247,
    "reference": "Exodus 20:3",
    "text": "“You shall have no other gods before me.",
    "translation": "ESV"
  },
  {
    "id": 248,
    "reference": "Exodus 20:12",
    "text": "“Honor your father and your mother, that your days may be long in the land that the Lord your God is giving you.",
    "translation": "ESV"
  },
  {
    "id": 249,
    "reference": "Exodus 33:14",
    "text": "And he said, “My presence will go with you, and I will give you rest.”",
    "translation": "ESV"
  },
  {
    "id": 250,
    "reference": "Leviticus 19:2",
    "text": "“Speak to all the congregation of the people of Israel and say to them, You shall be holy, for I the Lord your God am holy.",
    "translation": "ESV"
  },
  {
    "id": 251,
    "reference": "Leviticus 19:18",
    "text": "You shall not take vengeance or bear a grudge against the sons of your own people, but you shall love your neighbor as yourself: I am the Lord.",
    "translation": "ESV"
  },
  {
    "id": 252,
    "reference": "Leviticus 26:12",
    "text": "And I will walk among you and will be your God, and you shall be my people.",
    "translation": "ESV"
  },
  {
    "id": 253,
    "reference": "Numbers 14:18",
    "text": "‘The Lord is slow to anger and abounding in steadfast love, forgiving iniquity and transgression, but he will by no means clear the guilty, visiting the iniquity of the fathers on the children, to the third and the fourth generation.’",
    "translation": "ESV"
  },
  {
    "id": 254,
    "reference": "Numbers 23:19",
    "text": "God is not man, that he should lie,\n    or a son of man, that he should change his mind.\nHas he said, and will he not do it?\n    Or has he spoken, and will he not fulfill it?",
    "translation": "ESV"
  },
  {
    "id": 255,
    "reference": "Deuteronomy 4:29",
    "text": "But from there you will seek the Lord your God and you will find him, if you search after him with all your heart and with all your soul.",
    "translation": "ESV"
  },
  {
    "id": 256,
    "reference": "Deuteronomy 7:9",
    "text": "Know therefore that the Lord your God is God, the faithful God who keeps covenant and steadfast love with those who love him and keep his commandments, to a thousand generations,",
    "translation": "ESV"
  },
  {
    "id": 257,
    "reference": "Deuteronomy 8:3",
    "text": "And he humbled you and let you hunger and fed you with manna, which you did not know, nor did your fathers know, that he might make you know that man does not live by bread alone, but man lives by every word that comes from the mouth of the Lord.",
    "translation": "ESV"
  },
  {
    "id": 258,
    "reference": "Deuteronomy 31:8",
    "text": "It is the Lord who goes before you. He will be with you; he will not leave you or forsake you. Do not fear or be dismayed.”",
    "translation": "ESV"
  },
  {
    "id": 259,
    "reference": "Deuteronomy 32:4",
    "text": "“The Rock, his work is perfect,\n    for all his ways are justice.\nA God of faithfulness and without iniquity,\n    just and upright is he.",
    "translation": "ESV"
  },
  {
    "id": 260,
    "reference": "Deuteronomy 33:27",
    "text": "The eternal God is your dwelling place,\n    and underneath are the everlasting arms.\nAnd he thrust out the enemy before you\n    and said, ‘Destroy.’",
    "translation": "ESV"
  },
  {
    "id": 261,
    "reference": "Joshua 1:8",
    "text": "This Book of the Law shall not depart from your mouth, but you shall meditate on it day and night, so that you may be careful to do according to all that is written in it. For then you will make your way prosperous, and then you will have good success.",
    "translation": "ESV"
  },
  {
    "id": 262,
    "reference": "Joshua 23:14",
    "text": "“And now I am about to go the way of all the earth, and you know in your hearts and souls, all of you, that not one word has failed of all the good things that the Lord your God promised concerning you. All have come to pass for you; not one of them has failed.",
    "translation": "ESV"
  },
  {
    "id": 263,
    "reference": "Joshua 24:15",
    "text": "And if it is evil in your eyes to serve the Lord, choose this day whom you will serve, whether the gods your fathers served in the region beyond the River, or the gods of the Amorites in whose land you dwell. But as for me and my house, we will serve the Lord.”",
    "translation": "ESV"
  },
  {
    "id": 264,
    "reference": "Judges 2:18",
    "text": "Whenever the Lord raised up judges for them, the Lord was with the judge, and he saved them from the hand of their enemies all the days of the judge. For the Lord was moved to pity by their groaning because of those who afflicted and oppressed them.",
    "translation": "ESV"
  },
  {
    "id": 265,
    "reference": "Judges 21:25",
    "text": "In those days there was no king in Israel. Everyone did what was right in his own eyes.",
    "translation": "ESV"
  },
  {
    "id": 266,
    "reference": "Ruth 1:16",
    "text": "But Ruth said, “Do not urge me to leave you or to return from following you. For where you go I will go, and where you lodge I will lodge. Your people shall be my people, and your God my God.",
    "translation": "ESV"
  },
  {
    "id": 267,
    "reference": "1 Samuel 2:2",
    "text": "“There is none holy like the Lord:\n    for there is none besides you;\n    there is no rock like our God.",
    "translation": "ESV"
  },
  {
    "id": 268,
    "reference": "1 Samuel 12:24",
    "text": "Only fear the Lord and serve him faithfully with all your heart. For consider what great things he has done for you.",
    "translation": "ESV"
  },
  {
    "id": 269,
    "reference": "1 Samuel 15:22",
    "text": "And Samuel said,\n“Has the Lord as great delight in burnt offerings and sacrifices,\n    as in obeying the voice of the Lord?\nBehold, to obey is better than sacrifice,\n    and to listen than the fat of rams.",
    "translation": "ESV"
  },
  {
    "id": 270,
    "reference": "1 Samuel 16:7",
    "text": "But the Lord said to Samuel, “Do not look on his appearance or on the height of his stature, because I have rejected him. For the Lord sees not as man sees: man looks on the outward appearance, but the Lord looks on the heart.”",
    "translation": "ESV"
  },
  {
    "id": 271,
    "reference": "2 Samuel 7:28",
    "text": "And now, O Lord God, you are God, and your words are true, and you have promised this good thing to your servant.",
    "translation": "ESV"
  },
  {
    "id": 272,
    "reference": "2 Samuel 22:31",
    "text": "This God—his way is perfect;\n    the word of the Lord proves true;\n    he is a shield for all those who take refuge in him.",
    "translation": "ESV"
  },
  {
    "id": 273,
    "reference": "1 Kings 8:27",
    "text": "“But will God indeed dwell on the earth? Behold, heaven and the highest heaven cannot contain you; how much less this house that I have built!",
    "translation": "ESV"
  },
  {
    "id": 274,
    "reference": "1 Kings 8:39",
    "text": "then hear in heaven your dwelling place and forgive and act and render to each whose heart you know, according to all his ways (for you, you only, know the hearts of all the children of mankind),",
    "translation": "ESV"
  },
  {
    "id": 275,
    "reference": "1 Kings 18:21",
    "text": "And Elijah came near to all the people and said, “How long will you go limping between two different opinions? If the Lord is God, follow him; but if Baal, then follow him.” And the people did not answer him a word.",
    "translation": "ESV"
  },
  {
    "id": 276,
    "reference": "2 Kings 17:13",
    "text": "Yet the Lord warned Israel and Judah by every prophet and every seer, saying, “Turn from your evil ways and keep my commandments and my statutes, in accordance with all the Law that I commanded your fathers, and that I sent to you by my servants the prophets.”",
    "translation": "ESV"
  },
  {
    "id": 277,
    "reference": "1 Chronicles 16:34",
    "text": "Oh give thanks to the Lord, for he is good;\n    for his steadfast love endures forever!",
    "translation": "ESV"
  },
  {
    "id": 278,
    "reference": "1 Chronicles 29:11",
    "text": "Yours, O Lord, is the greatness and the power and the glory and the victory and the majesty, for all that is in the heavens and in the earth is yours. Yours is the kingdom, O Lord, and you are exalted as head above all.",
    "translation": "ESV"
  },
  {
    "id": 279,
    "reference": "2 Chronicles 7:14",
    "text": "if my people who are called by my name humble themselves, and pray and seek my face and turn from their wicked ways, then I will hear from heaven and will forgive their sin and heal their land.",
    "translation": "ESV"
  },
  {
    "id": 280,
    "reference": "2 Chronicles 16:9",
    "text": "For the eyes of the Lord run to and fro throughout the whole earth, to give strong support to those whose heart is blameless toward him. You have done foolishly in this, for from now on you will have wars.”",
    "translation": "ESV"
  },
  {
    "id": 281,
    "reference": "2 Chronicles 20:15",
    "text": "And he said, “Listen, all Judah and inhabitants of Jerusalem and King Jehoshaphat: Thus says the Lord to you, ‘Do not be afraid and do not be dismayed at this great horde, for the battle is not yours but God's.",
    "translation": "ESV"
  },
  {
    "id": 282,
    "reference": "Ezra 7:10",
    "text": "For Ezra had set his heart to study the Law of the Lord, and to do it and to teach his statutes and rules in Israel.",
    "translation": "ESV"
  },
  {
    "id": 283,
    "reference": "Esther 4:14",
    "text": "For if you keep silent at this time, relief and deliverance will rise for the Jews from another place, but you and your father's house will perish. And who knows whether you have not come to the kingdom for such a time as this?”",
    "translation": "ESV"
  },
  {
    "id": 284,
    "reference": "Job 1:21",
    "text": "And he said, “Naked I came from my mother's womb, and naked shall I return. The Lord gave, and the Lord has taken away; blessed be the name of the Lord.”",
    "translation": "ESV"
  },
  {
    "id": 285,
    "reference": "Job 13:15",
    "text": "Though he slay me, I will hope in him;\n    yet I will argue my ways to his face.",
    "translation": "ESV"
  },
  {
    "id": 286,
    "reference": "Job 23:10",
    "text": "But he knows the way that I take;\n    when he has tried me, I shall come out as gold.",
    "translation": "ESV"
  },
  {
    "id": 287,
    "reference": "Job 42:2",
    "text": "“I know that you can do all things,\n    and that no purpose of yours can be thwarted.",
    "translation": "ESV"
  },
  {
    "id": 288,
    "reference": "Psalm 1:3",
    "text": "He is like a tree\n    planted by streams of water\nthat yields its fruit in its season,\n    and its leaf does not wither.\nIn all that he does, he prospers.",
    "translation": "ESV"
  },
  {
    "id": 289,
    "reference": "Psalm 4:8",
    "text": "In peace I will both lie down and sleep;\n    for you alone, O Lord, make me dwell in safety.",
    "translation": "ESV"
  },
  {
    "id": 290,
    "reference": "Psalm 5:3",
    "text": "O Lord, in the morning you hear my voice;\n    in the morning I prepare a sacrifice for you and watch.",
    "translation": "ESV"
  },
  {
    "id": 291,
    "reference": "Psalm 18:2",
    "text": "The Lord is my rock and my fortress and my deliverer,\n    my God, my rock, in whom I take refuge,\n    my shield, and the horn of my salvation, my stronghold.",
    "translation": "ESV"
  },
  {
    "id": 292,
    "reference": "Psalm 18:30",
    "text": "This God—his way is perfect;\n    the word of the Lord proves true;\n    he is a shield for all those who take refuge in him.",
    "translation": "ESV"
  },
  {
    "id": 293,
    "reference": "Psalm 19:1",
    "text": "The heavens declare the glory of God,\n    and the sky above proclaims his handiwork.",
    "translation": "ESV"
  },
  {
    "id": 294,
    "reference": "Psalm 23:6",
    "text": "Surely goodness and mercy shall follow me\n    all the days of my life,\nand I shall dwell in the house of the Lord\n    forever.",
    "translation": "ESV"
  },
  {
    "id": 295,
    "reference": "Psalm 24:1",
    "text": "The earth is the Lord's and the fullness thereof,\n    the world and those who dwell therein,",
    "translation": "ESV"
  },
  {
    "id": 296,
    "reference": "Psalm 27:4",
    "text": "One thing have I asked of the Lord,\n    that will I seek after:\nthat I may dwell in the house of the Lord\n    all the days of my life,\nto gaze upon the beauty of the Lord\n    and to inquire in his temple.",
    "translation": "ESV"
  },
  {
    "id": 297,
    "reference": "Psalm 27:14",
    "text": "Wait for the Lord;\n    be strong, and let your heart take courage;\n    wait for the Lord!",
    "translation": "ESV"
  },
  {
    "id": 298,
    "reference": "Psalm 29:2",
    "text": "Ascribe to the Lord the glory due his name;\n    worship the Lord in the splendor of holiness.",
    "translation": "ESV"
  },
  {
    "id": 299,
    "reference": "Psalm 31:15",
    "text": "My times are in your hand;\n    rescue me from the hand of my enemies and from my persecutors!",
    "translation": "ESV"
  },
  {
    "id": 300,
    "reference": "Psalm 34:1",
    "text": "I will bless the Lord at all times;\n    his praise shall continually be in my mouth.",
    "translation": "ESV"
  },
  {
    "id": 301,
    "reference": "Psalm 34:18",
    "text": "The Lord is near to the brokenhearted\n    and saves the crushed in spirit.",
    "translation": "ESV"
  },
  {
    "id": 302,
    "reference": "Psalm 46:10",
    "text": "“Be still, and know that I am God.\n    I will be exalted among the nations,\n    I will be exalted in the earth!”",
    "translation": "ESV"
  },
  {
    "id": 303,
    "reference": "Psalm 51:17",
    "text": "The sacrifices of God are a broken spirit;\n    a broken and contrite heart, O God, you will not despise.",
    "translation": "ESV"
  },
  {
    "id": 304,
    "reference": "Psalm 63:1",
    "text": "O God, you are my God; earnestly I seek you;\n    my soul thirsts for you;\nmy flesh faints for you,\n    as in a dry and weary land where there is no water.",
    "translation": "ESV"
  },
  {
    "id": 305,
    "reference": "Psalm 68:19",
    "text": "Blessed be the Lord,\n    who daily bears us up;\n    God is our salvation. Selah",
    "translation": "ESV"
  },
  {
    "id": 306,
    "reference": "Psalm 86:5",
    "text": "For you, O Lord, are good and forgiving,\n    abounding in steadfast love to all who call upon you.",
    "translation": "ESV"
  },
  {
    "id": 307,
    "reference": "Psalm 103:8",
    "text": "The Lord is merciful and gracious,\n    slow to anger and abounding in steadfast love.",
    "translation": "ESV"
  },
  {
    "id": 308,
    "reference": "Psalm 103:17",
    "text": "But the steadfast love of the Lord is from everlasting to everlasting on those who fear him,\n    and his righteousness to children's children,",
    "translation": "ESV"
  },
  {
    "id": 309,
    "reference": "Psalm 107:1",
    "text": "Oh give thanks to the Lord, for he is good,\n    for his steadfast love endures forever!",
    "translation": "ESV"
  },
  {
    "id": 310,
    "reference": "Psalm 111:10",
    "text": "The fear of the Lord is the beginning of wisdom;\n    all those who practice it have a good understanding.\n    His praise endures forever!",
    "translation": "ESV"
  },
  {
    "id": 311,
    "reference": "Psalm 115:1",
    "text": "Not to us, O Lord, not to us, but to your name give glory,\n    for the sake of your steadfast love and your faithfulness!",
    "translation": "ESV"
  },
  {
    "id": 312,
    "reference": "Psalm 118:8",
    "text": "It is better to take refuge in the Lord\n    than to trust in man.",
    "translation": "ESV"
  },
  {
    "id": 313,
    "reference": "Psalm 119:18",
    "text": "Open my eyes, that I may behold\n    wondrous things out of your law.",
    "translation": "ESV"
  },
  {
    "id": 314,
    "reference": "Psalm 119:50",
    "text": "This is my comfort in my affliction,\n    that your promise gives me life.",
    "translation": "ESV"
  },
  {
    "id": 315,
    "reference": "Psalm 119:89",
    "text": "Forever, O Lord, your word\n    is firmly fixed in the heavens.",
    "translation": "ESV"
  },
  {
    "id": 316,
    "reference": "Psalm 119:133",
    "text": "Keep steady my steps according to your promise,\n    and let no iniquity get dominion over me.",
    "translation": "ESV"
  },
  {
    "id": 317,
    "reference": "Psalm 119:160",
    "text": "The sum of your word is truth,\n    and every one of your righteous rules endures forever.",
    "translation": "ESV"
  },
  {
    "id": 318,
    "reference": "Psalm 130:5",
    "text": "I wait for the Lord, my soul waits,\n    and in his word I hope;",
    "translation": "ESV"
  },
  {
    "id": 319,
    "reference": "Psalm 133:1",
    "text": "Behold, how good and pleasant it is\n    when brothers dwell in unity!",
    "translation": "ESV"
  },
  {
    "id": 320,
    "reference": "Psalm 136:1",
    "text": "Give thanks to the Lord, for he is good,\n    for his steadfast love endures forever.",
    "translation": "ESV"
  },
  {
    "id": 321,
    "reference": "Psalm 143:8",
    "text": "Let me hear in the morning of your steadfast love,\n    for in you I trust.\nMake me know the way I should go,\n    for to you I lift up my soul.",
    "translation": "ESV"
  },
  {
    "id": 322,
    "reference": "Psalm 145:3",
    "text": "Great is the Lord, and greatly to be praised,\n    and his greatness is unsearchable.",
    "translation": "ESV"
  },
  {
    "id": 323,
    "reference": "Psalm 150:6",
    "text": "Let everything that has breath praise the Lord!\nPraise the Lord!",
    "translation": "ESV"
  },
  {
    "id": 324,
    "reference": "Proverbs 2:6",
    "text": "For the Lord gives wisdom;\n    from his mouth come knowledge and understanding;",
    "translation": "ESV"
  },
  {
    "id": 325,
    "reference": "Proverbs 8:17",
    "text": "I love those who love me,\n    and those who seek me diligently find me.",
    "translation": "ESV"
  },
  {
    "id": 326,
    "reference": "Proverbs 10:12",
    "text": "Hatred stirs up strife,\n    but love covers all offenses.",
    "translation": "ESV"
  },
  {
    "id": 327,
    "reference": "Proverbs 12:15",
    "text": "The way of a fool is right in his own eyes,\n    but a wise man listens to advice.",
    "translation": "ESV"
  },
  {
    "id": 328,
    "reference": "Proverbs 14:29",
    "text": "Whoever is slow to anger has great understanding,\n    but he who has a hasty temper exalts folly.",
    "translation": "ESV"
  },
  {
    "id": 329,
    "reference": "Proverbs 15:3",
    "text": "The eyes of the Lord are in every place,\n    keeping watch on the evil and the good.",
    "translation": "ESV"
  },
  {
    "id": 330,
    "reference": "Proverbs 17:17",
    "text": "A friend loves at all times,\n    and a brother is born for adversity.",
    "translation": "ESV"
  },
  {
    "id": 331,
    "reference": "Proverbs 18:24",
    "text": "A man of many companions may come to ruin,\n    but there is a friend who sticks closer than a brother.",
    "translation": "ESV"
  },
  {
    "id": 332,
    "reference": "Proverbs 20:24",
    "text": "A man's steps are from the Lord;\n    how then can man understand his way?",
    "translation": "ESV"
  },
  {
    "id": 333,
    "reference": "Proverbs 21:2",
    "text": "Every way of a man is right in his own eyes,\n    but the Lord weighs the heart.",
    "translation": "ESV"
  },
  {
    "id": 334,
    "reference": "Proverbs 28:13",
    "text": "Whoever conceals his transgressions will not prosper,\n    but he who confesses and forsakes them will obtain mercy.",
    "translation": "ESV"
  },
  {
    "id": 335,
    "reference": "Proverbs 30:5",
    "text": "Every word of God proves true;\n    he is a shield to those who take refuge in him.",
    "translation": "ESV"
  },
  {
    "id": 336,
    "reference": "Ecclesiastes 3:11",
    "text": "He has made everything beautiful in its time. Also, he has put eternity into man's heart, yet so that he cannot find out what God has done from the beginning to the end.",
    "translation": "ESV"
  },
  {
    "id": 337,
    "reference": "Ecclesiastes 5:10",
    "text": "He who loves money will not be satisfied with money, nor he who loves wealth with his income; this also is vanity.",
    "translation": "ESV"
  },
  {
    "id": 338,
    "reference": "Ecclesiastes 7:8",
    "text": "Better is the end of a thing than its beginning,\n    and the patient in spirit is better than the proud in spirit.",
    "translation": "ESV"
  },
  {
    "id": 339,
    "reference": "Ecclesiastes 9:11",
    "text": "Again I saw that under the sun the race is not to the swift, nor the battle to the strong, nor bread to the wise, nor riches to the intelligent, nor favor to those with knowledge, but time and chance happen to them all.",
    "translation": "ESV"
  },
  {
    "id": 340,
    "reference": "Ecclesiastes 11:9",
    "text": "Rejoice, O young man, in your youth, and let your heart cheer you in the days of your youth. Walk in the ways of your heart and the sight of your eyes. But know that for all these things God will bring you into judgment.",
    "translation": "ESV"
  },
  {
    "id": 341,
    "reference": "Isaiah 1:18",
    "text": "“Come now, let us reason together, says the Lord:\nthough your sins are like scarlet,\n    they shall be as white as snow;\nthough they are red like crimson,\n    they shall become like wool.",
    "translation": "ESV"
  },
  {
    "id": 342,
    "reference": "Isaiah 12:2",
    "text": "“Behold, God is my salvation;\n    I will trust, and will not be afraid;\nfor the Lord God is my strength and my song,\n    and he has become my salvation.”",
    "translation": "ESV"
  },
  {
    "id": 343,
    "reference": "Isaiah 25:1",
    "text": "O Lord, you are my God;\n    I will exalt you; I will praise your name,\nfor you have done wonderful things,\n    plans formed of old, faithful and sure.",
    "translation": "ESV"
  },
  {
    "id": 344,
    "reference": "Isaiah 30:21",
    "text": "And your ears shall hear a word behind you, saying, “This is the way, walk in it,” when you turn to the right or when you turn to the left.",
    "translation": "ESV"
  },
  {
    "id": 345,
    "reference": "Isaiah 40:8",
    "text": "The grass withers, the flower fades,\n    but the word of our God will stand forever.",
    "translation": "ESV"
  },
  {
    "id": 346,
    "reference": "Isaiah 41:13",
    "text": "For I, the Lord your God,\n    hold your right hand;\nit is I who say to you, “Fear not,\n    I am the one who helps you.”",
    "translation": "ESV"
  },
  {
    "id": 347,
    "reference": "Isaiah 43:25",
    "text": "“I, I am he\n    who blots out your transgressions for my own sake,\n    and I will not remember your sins.",
    "translation": "ESV"
  },
  {
    "id": 348,
    "reference": "Isaiah 44:22",
    "text": "I have blotted out your transgressions like a cloud\n    and your sins like mist;\nreturn to me, for I have redeemed you.",
    "translation": "ESV"
  },
  {
    "id": 349,
    "reference": "Isaiah 46:4",
    "text": "even to your old age I am he,\n    and to gray hairs I will carry you.\nI have made, and I will bear;\n    I will carry and will save.",
    "translation": "ESV"
  },
  {
    "id": 350,
    "reference": "Isaiah 48:17",
    "text": "Thus says the Lord,\n    your Redeemer, the Holy One of Israel:\n“I am the Lord your God,\n    who teaches you to profit,\n    who leads you in the way you should go.",
    "translation": "ESV"
  },
  {
    "id": 351,
    "reference": "Isaiah 50:4",
    "text": "The Lord God has given me\n    the tongue of those who are taught,\nthat I may know how to sustain with a word\n    him who is weary.\nMorning by morning he awakens;\n    he awakens my ear\n    to hear as those who are taught.",
    "translation": "ESV"
  },
  {
    "id": 352,
    "reference": "Isaiah 52:7",
    "text": "How beautiful upon the mountains\n    are the feet of him who brings good news,\nwho publishes peace, who brings good news of happiness,\n    who publishes salvation,\n    who says to Zion, “Your God reigns.”",
    "translation": "ESV"
  },
  {
    "id": 353,
    "reference": "Isaiah 54:10",
    "text": "For the mountains may depart\n    and the hills be removed,\nbut my steadfast love shall not depart from you,\n    and my covenant of peace shall not be removed,”\n    says the Lord, who has compassion on you.",
    "translation": "ESV"
  },
  {
    "id": 354,
    "reference": "Isaiah 55:11",
    "text": "so shall my word be that goes out from my mouth;\n    it shall not return to me empty,\nbut it shall accomplish that which I purpose,\n    and shall succeed in the thing for which I sent it.",
    "translation": "ESV"
  },
  {
    "id": 355,
    "reference": "Isaiah 57:15",
    "text": "For thus says the One who is high and lifted up,\n    who inhabits eternity, whose name is Holy:\n“I dwell in the high and holy place,\n    and also with him who is of a contrite and lowly spirit,\nto revive the spirit of the lowly,\n    and to revive the heart of the contrite.",
    "translation": "ESV"
  },
  {
    "id": 356,
    "reference": "Isaiah 58:11",
    "text": "And the Lord will guide you continually\n    and satisfy your desire in scorched places\n    and make your bones strong;\nand you shall be like a watered garden,\n    like a spring of water,\n    whose waters do not fail.",
    "translation": "ESV"
  },
  {
    "id": 357,
    "reference": "Isaiah 59:1",
    "text": "Behold, the Lord's hand is not shortened, that it cannot save,\n    or his ear dull, that it cannot hear;",
    "translation": "ESV"
  },
  {
    "id": 358,
    "reference": "Isaiah 60:1",
    "text": "Arise, shine, for your light has come,\n    and the glory of the Lord has risen upon you.",
    "translation": "ESV"
  },
  {
    "id": 359,
    "reference": "Isaiah 62:4",
    "text": "You shall no more be termed Forsaken,\n    and your land shall no more be termed Desolate,\nbut you shall be called My Delight Is in Her,\n    and your land Married;\nfor the Lord delights in you,\n    and your land shall be married.",
    "translation": "ESV"
  },
  {
    "id": 360,
    "reference": "Isaiah 65:24",
    "text": "Before they call I will answer;\n    while they are yet speaking I will hear.",
    "translation": "ESV"
  },
  {
    "id": 361,
    "reference": "Isaiah 66:2",
    "text": "All these things my hand has made,\n    and so all these things came to be,\ndeclares the Lord.\nBut this is the one to whom I will look:\n    he who is humble and contrite in spirit\n    and trembles at my word.",
    "translation": "ESV"
  },
  {
    "id": 362,
    "reference": "Jeremiah 10:12",
    "text": "It is he who made the earth by his power,\n    who established the world by his wisdom,\n    and by his understanding stretched out the heavens.",
    "translation": "ESV"
  },
  {
    "id": 363,
    "reference": "Jeremiah 15:16",
    "text": "Your words were found, and I ate them,\n    and your words became to me a joy\n    and the delight of my heart,\nfor I am called by your name,\n    O Lord, God of hosts.",
    "translation": "ESV"
  },
  {
    "id": 364,
    "reference": "Jeremiah 23:24",
    "text": "Can a man hide himself in secret places so that I cannot see him? declares the Lord. Do I not fill heaven and earth? declares the Lord.",
    "translation": "ESV"
  },
  {
    "id": 365,
    "reference": "Jeremiah 24:7",
    "text": "I will give them a heart to know that I am the Lord, and they shall be my people and I will be their God, for they shall return to me with their whole heart.",
    "translation": "ESV"
  }
];

export default MOTIVATIONAL_VERSES_365;
